import React from "react";
import "../components/HeroSection.css";

function HeroSection() {
  return (
    <div className="hero-section">
      <div className="hero-image"></div>
    </div>
  );
}

export default HeroSection;
